import { render, staticRenderFns } from "./centerLeft3.vue?vue&type=template&id=ff9fae30&scoped=true&"
import script from "./centerLeft3.vue?vue&type=script&lang=js&"
export * from "./centerLeft3.vue?vue&type=script&lang=js&"
import style0 from "./centerLeft3.vue?vue&type=style&index=0&id=ff9fae30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9fae30",
  null
  
)

export default component.exports